import { combineReducers } from 'redux';

import documents, { IDocumentsState } from './documents';
import links, { ILinksState } from './links';
import images, { IImagesState } from './images';

export interface ISupplierAttachmentsState {
  links: ILinksState;
  images: IImagesState;
  documents: IDocumentsState;
}

const customerEnquiryReducer = combineReducers<ISupplierAttachmentsState>({
  documents,
  links,
  images
});

export default customerEnquiryReducer;
